module.exports = __webpack_public_path__ + "assets/1d03eab131ce407bfa76d313316b7151.mp3";